/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import { Card, Grid, Typography, Box } from '@mui/material';
import { shadowColor } from 'theme/color';
import {
  fontsize16,
  fontsize24,
  poppins400,
  poppins500,
} from 'theme/common.style';

import {
  // detailsContent,
  contentBox,
  detailsBox,
  detailsLabel,
  detailsValue,
} from './PropertyProfileDetails.Style';

function PropertyProfileDetails(props) {
  return (
    <Card
      variant="outlined"
      style={{
        borderRadius: '8px',
        boxShadow: `0px 1px 8px ${shadowColor}`,
        padding: '30px 20px',
        marginTop: '14px',
      }}
    >
      <Grid>
        <Grid sx={{ ...poppins500, ...fontsize24 }}>Details</Grid>
        <Grid
          sx={{ display: 'flex', gap: '15px', justifyContent: 'space-between' }}
        >
          <ul style={contentBox}>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Property ID</Typography>
              <Typography sx={detailsValue}>HZ35</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Price</Typography>
              <Typography sx={detailsValue}>$346,000</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Property Size</Typography>
              <Typography sx={detailsValue}>2600 Sq Ft</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Bedrooms</Typography>
              <Typography sx={detailsValue}>05</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Bathrooms</Typography>
              <Typography sx={detailsValue}>08</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Deposit</Typography>
              <Typography sx={detailsValue}>20%</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Pool Size</Typography>
              <Typography sx={detailsValue}>300 Sq Ft</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Last Remodal Year</Typography>
              <Typography sx={detailsValue}>2010</Typography>
            </li>
          </ul>
          <ul style={contentBox}>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Garage</Typography>
              <Typography sx={detailsValue}>1</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Garage Size</Typography>
              <Typography sx={detailsValue}>200 Sq Ft</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Year Built</Typography>
              <Typography sx={detailsValue}>2016</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Property Type</Typography>
              <Typography sx={detailsValue}>Single Family Home</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Property Status</Typography>
              <Typography sx={detailsValue}>08</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Amenities</Typography>
              <Typography sx={detailsValue}>Clubhouse</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Additional Rooms</Typography>
              <Typography sx={detailsValue}>Guest Bath</Typography>
            </li>
            <li style={detailsBox}>
              <Typography sx={detailsLabel}>Equipment</Typography>
              <Typography sx={detailsValue}>Grill, Gas</Typography>
            </li>
          </ul>
        </Grid>
      </Grid>
    </Card>
  );
}

PropertyProfileDetails.propTypes = {};

export default PropertyProfileDetails;
